module.exports = __webpack_public_path__ + "static/media/BRACELET.f50bedc1.svg";